module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAGBAMAAADj6an2AAAALVBMVEUAAACampqampqampqZmZmZmZmZmZmZmZmampqampqbm5uampqcnJydnZ2ZmZk+9xHIAAAADnRSTlMA+Cvpluzh06aVVEQxGsQoqbkAAAAsSURBVAjXY+h7KCh2gKHu3bt3CxiU3717ycDAZPfOgYGBQfUJAxDwbmBgAAAVZQxbL/6z+AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon_down.png
// module id = F689
// module chunks = 1